import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { GroupEditBasic } from "@shared/models/analytics/group"
import type { GroupAttributes } from "@shared/models/group"
import Patch from "@shared/models/patch-updater"
import type { PreparedAction } from "@shared/actions/action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "@shared/actions/create-narrative"

interface Payload {
  groupId: string
  value: GroupAttributes["branding"]
  originalValue: GroupAttributes["branding"]
}

export default function groupChangeBrandingAction(payload: Payload): PreparedAction {
  return {
    name: "GROUP_CHANGE_BRANDING",
    payload: payload,
    patches: patches(payload),
    undoPatches: undoPatches(payload),
    narrative: partial(narrative, payload),
  }
}

function patches(payload: Payload) {
  let patch = Patch.create("group", payload.groupId).set(`attributes.branding`, payload.value).patch
  return [patch]
}

function undoPatches(payload: Payload) {
  let patch = Patch.create("group", payload.groupId).set(
    `attributes.branding`,
    payload.originalValue
  ).patch
  return [patch]
}

function narrative(payload: Payload, _findFn: FindFn, _userId: string): Narrative {
  let newEvent: GroupEditBasic = {
    ...createBlankEvent(),
    root_id: payload.groupId,
    root_type: "group",
    date_plan_scheduled_for: null,

    primary_verb: "edit",
    primary_possessive: "owns",

    primary_object_type: "group",
    primary_object_id: payload.groupId,
    primary_object_specifier: "branding",
    primary_object_id_and_ancestor_ids: [payload.groupId],

    adverbial_verb: null,

    adverbial_object_type: null,
    adverbial_object_id: null,
    adverbial_object_specifier: null,
    adverbial_object_id_and_ancestor_ids: [payload.groupId],
  }
  return {
    title: "Changed Group Logo or Colors",
    titleForAnalytics: "Group - Changed Branding",
    description: `Changed the logo or colors`,
    context: {
      groupId: payload.groupId,
    },
    activity: null,
    newAnalyticsEvents: [newEvent],
  }
}
